module.exports.config = {
  declarative: true,
  "render-module": {
    name: "PieceListRenderModule",
    path: "front/piece-list-render.module"
  },
  "cms-module": {
    name: "PieceListCmsModule",
    path: "front/piece-list-cms.module"
  },
  definition: {
    type: "list",
    name: "PieceListDefinition",
    group: "Components",
    availablePlatforms: ["web"],
    description: "Lista",
    isNew: true,
    isOnlyAvailableWithCollections: true,
    fields: [
      { name: "linkedCollection", label: "Vincular colección", type: "linkedCollection", mandatory: true },
      {
        name: "listFields",
        label: "Campos de la lista",
        type: "groupCollapsable",
        isFolded: true,
        flattenFields: true,
        fields: [
          { name: "listTitle", label: "Título de la lista", type: "plainText" },
          { name: "collectionField", label: "Campo de la colección", type: "collectionFieldSelector", mandatory: true },
          { name: "link", label: "URL de destino", type: "link" },
        ]
      },
      {
        name: "listStyles",
        label: "Estilos de la lista",
        type: "groupCollapsable",
        fields: [
          { name: "numberOfColumns", label: "Número de columnas", type: "numberForDesktopAndMobile" },
          { name: "columnSpacing", label: "Separación entre columnas", type: "units" },
          { name: "rowSpacing", label: "Separación entre filas", type: "units" },
          {
            name: "enableBullets",
            label: "Mostrar bullets",
            type: "groupToggleable",
            flattenFields: true,
            fields: [
              {
                name: "listType",
                label: "Tipo de lista",
                type: "optionButtons",
                defaultValue: "unordered",
                values: [
                  { label: "Desordenada", value: "unordered" },
                  { label: "Ordenada", value: "ordered" }
                ]
              },
              {
                name: "bulletType",
                label: "Tipo de bullet",
                type: "options",
                defaultValue: "disc",
                values: [
                  { label: "Números", value: "decimal" },
                  { label: "Letras", value: "upper-latin" },
                  { label: "Números romanos", value: "upper-roman" },
                  { label: "Guión", value: "dash" },
                  { label: "Círculo", value: "disc" },
                  { label: "Cuadrado", value: "square" },
                  { label: "Personalizado", value: "customBullet", shouldDisplayWhenSelected: "customIcon" }
                ]
              }
            ]
          }
        ]
      },
      {
        name: "theme",
        label: "Aspecto de la lista",
        type: "options",
        section: "styles",
        defaultValue: "default",
        values: [
          { label: "Por defecto", value: "default" },
          {
            label: "Clases personalizadas",
            value: "customClasses",
            shouldDisplayWhenSelected: "customClassesList",
            jsonPath: "styles.customClassesList"
          }
        ]
      }
    ]
  }
};
